import { allElements } from "constants/constants";
import { IMillFilters } from "pages/Corporate/Locations/MillDashboards/SummaryReport/components/SummaryReportFilters/SummaryReportFiltersInterfaces";
import { ICorporateDashboardFilters } from "pages/Corporate/CorporateDashboard/useCorporateDashboardFilters";

export const mapCorporateFiltersToMillFilters = (filters: ICorporateDashboardFilters): IMillFilters => {
    const productionLine = Array.isArray(filters.productionLine)
        ? filters.productionLine.includes(allElements)
            ? undefined
            : (filters.productionLine as (string | number)[]).join(",")
        : filters.productionLine && filters.productionLine !== allElements
        ? (filters.productionLine as string | number)
        : undefined;

    const machineCenter = Array.isArray(filters.machineCenter)
        ? filters.machineCenter.includes(allElements)
            ? undefined
            : (filters.machineCenter as (string | number)[])
        : filters.machineCenter && filters.machineCenter !== allElements
        ? (filters.machineCenter as string)
        : undefined;

    return {
        startDate: filters.startDate,
        endDate: filters.endDate,
        displayIn: filters.displayIn,
        productionLine,
        machineCenter,
        functionalLocation: undefined,
        shift: undefined,
        failureTypes: undefined,
    };
};
